import React from 'react';
import { Section, SectionHeading } from './Shared';
const criteria = [{
  title: 'Hai già studiato Qi Gong, Tai Chi o Chi Kung',
  detail: 'E vuoi organizzare meglio ciò che conosci'
}, {
  title: 'Insegni lezioni individuali o di gruppo',
  detail: 'Con persone di livelli ed esigenze diverse'
}, {
  title: 'Ti capita di preparare l’incontro all’ultimo momento',
  detail: 'E vuoi una base pronta da consultare prima e durante la lezione'
}, {
  title: 'Desideri spiegare i movimenti con più ordine',
  detail: 'Con riferimenti visivi e indicazioni sempre coerenti'
}, {
  title: 'Vuoi seguire meglio l’evoluzione degli allievi',
  detail: 'Con schede, note e osservazioni nel tempo'
}, {
  title: 'Cerchi un sistema pratico da adattare al tuo stile',
  detail: 'Non un metodo rigido da applicare alla lettera'
}];
export const WhoItsFor = () => <Section data-id="element-273" data-mp="3q4kifhu3c5qk">
    <SectionHeading eyebrow="Per chi è pensato" className="mb-8" data-id="element-274" data-mp="3q2rieldzgjrj">
      Per chi insegna, o vuole insegnare, con maggiore struttura
    </SectionHeading>

    <div className="max-w-3xl mx-auto glass-panel rounded-sm overflow-hidden divide-y divide-brand-purpleDark/10" data-id="element-275" data-mp="1zonhk6qesxvk">
      {criteria.map(row => <div key={row.title} className="flex flex-col sm:flex-row sm:items-center gap-0.5 sm:gap-4 px-5 py-2.5" data-id="element-276" data-mp="1vq80skkx8lql">
          <p className="text-sm font-medium text-brand-purpleDark sm:w-1/2" data-id="element-277" data-mp="1qv24qsxt1qos">
            {row.title}
          </p>
          <p className="text-sm text-brand-burgundy/90 sm:w-1/2" data-id="element-278" data-mp="1gyz45rilq03y">
            {row.detail}
          </p>
        </div>)}
    </div>

    <p className="text-center mt-8 max-w-2xl mx-auto text-lg md:text-xl font-display italic text-brand-purpleDark" data-id="element-279" data-mp="1bz2yzoy642mt">
      “Non devi cambiare il tuo modo di insegnare. Devi solo avere una struttura
      che ti aiuti a utilizzarlo con più continuità.”
    </p>
  </Section>;